import React from 'react';
import Button from '../../../components/molecules/buttons';
import Stepper from '../../../components/molecules/steppers';
import Forms from '../../../components/molecules/forms';
import useProducts from './hooks';
import DataListHandler from '../../../components/layout/body/data-list-handler';
import RenderCardProduct from './card';
import RenderPagination from '../../../components/molecules/pagination';
import LandingHeader from '../../../components/layout/header/landing';

function Products():React.ReactElement {
  const {
    product, step, category, search, navigation, page, onSearch,
  } = useProducts();

  return (
    <div className="py-4">
      <LandingHeader title="Products" />
      <div className="px-4 px-xl-5">
        <div className="row mb-md-0 mb-4">
          <div className="col-xl-3 col-lg-4 col-md-5 col-12">
            <Stepper.Slide
              labels={['All', 'Wholesale']}
              step={step.current}
              setStep={step.setCurrent}
            />
          </div>
          <div className="col-xl-5 offset-xl-4 col-lg-5 offset-lg-3 col-md-7 offset-0 col-12">
            <div className="row">
              <div className="col-sm-7 pe-0 mb-sm-0 mb-4">
                <Forms.ReactSelect.Default
                  id="category"
                  placeholder="Select Category"
                  options={category.list}
                  disabled={category.load || !product.list}
                  value={category.current}
                  onChange={(e) => {
                    search.setCurrent('');
                    page.setCurrent(1);
                    if (e) category.setCurrent(e);
                  }}
                  isSearchable={false}
                />
              </div>
              <div className="col-sm-5">
                <Button.Default id="addUser" type="button" label="Add Product" onClick={navigation.add} />
              </div>
            </div>
          </div>
        </div>
        <form
          onSubmit={onSearch}
          className="mb-4"
          style={{ height: '40px' }}
        >
          <Forms.Search
            placeholder="Search"
            value={search.current}
            onChange={(e) => {
              if (e) search.setCurrent(e.target.value);
            }}
            disabled={!product.list}
          />
        </form>
        <DataListHandler isData={!!product.list && !!product.list.data.length} isLoading={product.load}>
          <div className="row">
            {product.list?.data?.map((prod) => (
              <div
                key={prod.id}
                className="col-xxl-3 col-lg-4 col-md-6 col-sm-12 mb-2"
              >
                <RenderCardProduct data={prod} category={category.current} refetchProduct={product.refetch} />
              </div>
            ))}
          </div>
        </DataListHandler>
        <div className="d-flex justify-content-md-end justify-content-center mt-4 w-100">
          <RenderPagination
            currentPage={page.current}
            setCurrentPage={page.setCurrent}
            totalPage={product.list?.totalPage ?? 1}
          />
        </div>
      </div>
    </div>
  );
}

export default Products;
